import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { ValetDamageCheckModalComponent } from 'src/app/shared/modals/valet-damage-check-modal/valet-damage-check-modal.component';

@Component({
    selector: 'app-valetinventorydetails',
    templateUrl: './valetinventorydetails.component.html',
    styleUrls: ['./valetinventorydetails.component.scss'],
    standalone: false
})
export class ValetInventoryDetailsComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;
  public NewMessageContent: string = '';
  public SendingMessage: boolean = false;

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, public router: Router, public orgService: OrganizationsService, private modal: SimpleModalService) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("valet/inventory/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }

  openDamageCheckImage(image: any, title: string): void {
    this.modal.addModal(ValetDamageCheckModalComponent, {
      ModalTitle: title,
      MediaId: image.MediaId,
      DamageCheckCoordinates: image.DamageCheckCoordinates || []
    });
  }

  damageDotColor(type: number): string {
    switch (type) {
      case 0: return '#fb8c00';
      case 1: return '#e53935';
      default: return '#1e88e5';
    }
  }

  sendMessage(event?: Event): void {
    if (event) {
      const ke = event as KeyboardEvent;
      if (ke.shiftKey) return;
      event.preventDefault();
    }

    const content = this.NewMessageContent?.trim();
    if (!content || this.SendingMessage) return;

    this.SendingMessage = true;
    this.apiService.Post<any>("valet/inventory/" + this.ModelId + "/messages", { Content: content }).then(result => {
      this.Model = result;
      this.NewMessageContent = '';
      this.SendingMessage = false;
    }, () => {
      this.SendingMessage = false;
    });
  }
}
